// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const FileUpload = React.forwardRef(function FileUpload(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"/></SvgIcon>;
});
export default FileUpload;
